// src/features/reporting/services/reporting.js
import { apiClient } from '../../../services/api/client';

export const reportingAPI = {
  getReportTypes: () =>
    apiClient.get('/api/v1/reports/types'),

  generateReport: (reportType, params = {}) =>
    apiClient.post(
      `/api/v1/reports/${reportType}/generate`,
      { params },
      { responseType: 'blob' },
    ),
};
